export default "__VITE_ASSET__C3VGfoZ3__"